import styled from 'styled-components'

const StyledMember = styled.div`
  text-align: center;

  img {
    max-height: 32rem;
    max-width: 32rem;
    border-radius: 100%;
    object-fit: cover;
    width: 100%;
    margin-bottom: 1.6rem;
  }

  h5 {
    font-weight: 400;
    font-size: 1.6rem;
  }

  p {
    font-size: 1.4rem;
    color: var(--dark-1);
  }

  h5,
  p {
    font-family: 'Neue Montreal';
    line-height: 2.8rem;
    letter-spacing: 0.02rem;
    margin: 0;
  }
`

type IProps = {
  imageUrl: string
  name: string
  position: string
}

const TeamMember = ({ imageUrl, name, position }: IProps) => (
  <StyledMember>
    <img src={imageUrl} alt={name} />
    <h5>{name}</h5>
    <p>{position}</p>
  </StyledMember>
)

export default TeamMember
